import React, { Component } from 'react';
import $ from "jquery";
import Cookies from "js-cookie";
//import ReCAPTCHA from "react-google-recaptcha";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './App.css';

//const version = "v.1.0.0";

var _pid = 2 //id progetto
var _lemma = false

const ico_profilo =
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="black" className="bi bi-person-circle" viewBox="0 0 16 16">
  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
  <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
</svg>

const ico_bookmark_add =
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="black" className="bi bi-bookmark-plus" viewBox="0 0 16 16">
  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>
  <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>
</svg>

const ico_bookmark_del =
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#996c95" className="bi bi-bookmark-dash" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M5.5 6.5A.5.5 0 0 1 6 6h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/>
  <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>
</svg>

const ico_stampa =
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="black" className="bi bi-printer" viewBox="0 0 16 16">
  <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
  <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
</svg>

const ico_email =
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="black" className="bi bi-envelope" viewBox="0 0 16 16">
  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
</svg>

const ico_up_mobile =
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#996c95" className="bi bi-arrow-up-circle" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>
</svg>

//const accessCode = 'ff18c37528738d96f77ca9890d5d0215940c014fea1bf5b18bc3943c7eb81234';

class App extends Component {

  constructor(props, context) {

    super(props, context);

    //Cookies.remove('ctcae_user', { path: '/' }); //pulizia x test

    let mobile = window.screen.width < 768 ? true : false;

    let db_it = window.db_it
    let categorie_it = []
    for (let ii=0; ii<db_it.length; ii++) {
      if (!categorie_it.includes(db_it[ii].soc)) categorie_it.push(db_it[ii].soc)
    }

    let db_en = window.db_en
    let categorie_en = []
    for (let ii=0; ii<db_en.length; ii++) {
      if (!categorie_en.includes(db_en[ii].soc)) categorie_en.push(db_en[ii].soc)
    }

    let user = false
    if (typeof (Cookies.get('ctcae_user')) !== 'undefined') user = JSON.parse(Cookies.get('ctcae_user'))

    let pagina = 'splash'
    //if (typeof (Cookies.get('ctcae_splash')) !== 'undefined') pagina = 'home'

    this.state = {
      lang:'IT',
      user:user,
      mobile:mobile,
      pagina:pagina,
      lemma:false,
      categoria:'',
      filtro:'',
      bookmarks:[],
      lemmi_bookmarked:[],
      categorie:categorie_it.sort(),
      categorie_it:categorie_it.sort(),
      categorie_en:categorie_en.sort(),
      lemmi:window.db_it.sort((a,b) => (a.termine > b.termine) ? 1 : ((b.termine > a.termine) ? -1 : 0)),
      lemmi_it:window.db_it.sort((a,b) => (a.termine > b.termine) ? 1 : ((b.termine > a.termine) ? -1 : 0)),
      lemmi_en:window.db_en.sort((a,b) => (a.termine > b.termine) ? 1 : ((b.termine > a.termine) ? -1 : 0)),
    };

  }

  componentDidMount() {

    if (this.state.user) this.getBookmarks(this.state.user.id)
    /*
    if (typeof (Cookies.get('ctcae_splash')) === 'undefined') {
      Cookies.set('ctcae_splash', true, { expires: 30 });
    }
    */
  }

  doLogin = (e) => {

    e.preventDefault()
    e.stopPropagation()

    let data = $("#the-login-form").serialize()+'&from='+_pid

  	$.ajax({
  			type: "POST",
  			url:  "php/login.php",
  			data: data
  		})
  		.done(function(data) {
        if (data) {
          let user = JSON.parse(data)
          //console.log(user)
          this.setState({user:user, pagina:'home'});
          Cookies.set('ctcae_user', JSON.stringify(user), { expires: 30 });
          this.getBookmarks(user.id)
        } else {
  			  $("#the-msg").html("username o password errata")
          setTimeout(function(){ $("#the-msg").html('') }, 3000)
        }
  		}.bind(this))
  		.fail(function(jqXHR, textStatus) {
  			$("#the-msg").html("Ops, qualcosa è andato storto...")
  		});
  }

  doLogout = () => {
    this.setState({user:false, bookmarks:[], pagina:'home'});
    Cookies.remove('ctcae_user', { path: '/' });
  }

  changeCategoria = (e) => {
    this.setState({categoria: e.target.value});
  }

  filterLemma = (e) => {
    this.setState({filtro: e.target.value});
  }

  showLemma = (id) => {

    let lemma = this.state.lemmi.filter(function(d) { return d.medra===id; });
    this.setState({lemma: lemma[0], medra_on: id});
    _lemma = lemma[0]

		if (this.state.mobile) $('html,body').animate({scrollTop: $("#div-scheda").offset().top-10},'slow');
  }

  changeDB = (lang) => {

    if (lang===this.state.lang) return;

    let lemmi = false;
    let categorie = false;
    let categoria = '';

    if (lang==='IT') {
      lemmi = this.state.lemmi_it;
      categorie = this.state.categorie_it;
      if (this.state.categoria) categoria = window.cat_it[window.cat_en.indexOf(this.state.categoria)]
    }
    if (lang==='EN') {
      lemmi = this.state.lemmi_en;
      categorie = this.state.categorie_en;
      if (this.state.categoria) categoria = window.cat_en[window.cat_it.indexOf(this.state.categoria)]
    }

    this.creaListaLemmiBookmarked(lemmi,this.state.bookmarks);

    let lemma = lemmi.filter(function(d) { return d.medra===this.state.medra_on }.bind(this));
    _lemma = lemma[0];

    this.setState({lang:lang, lemmi:lemmi, categorie:categorie, categoria:categoria, filtro:'', lemma: lemma[0]});

    //variante semplificata con azzeramento dei dati selezionati
    //
    /*
    if (lang==='IT') {
      this.creaListaLemmiBookmarked(this.state.lemmi_it,this.state.bookmarks)
      this.setState({lemmi:this.state.lemmi_it, categorie:this.state.categorie_it, categoria:'', lemma:false, filtro:''});
    }
    if (lang==='EN') {
      this.creaListaLemmiBookmarked(this.state.lemmi_en,this.state.bookmarks)
      this.setState({lemmi:this.state.lemmi_en, categorie:this.state.categorie_en, categoria:'', lemma:false, filtro:''});
    }
    */
  }

  registrazione = (act) => {

  	$('#IframeId-16by9').attr('src', 'https://registrazione.forumservice.net/?act='+act)
    $('#modal_reg_16by9').modal('show')
  }

  getTermine = (id) => {

    let lemmi = this.state.lemmi
    for (let ii=0; ii<lemmi.length; ii++) {
      if (lemmi[ii].medra===id) return (lemmi[ii].termine)
    }
  }

  getBookmarks = (uid) => {

  	$.ajax({
  			type: "POST",
  			url:  "php/services.php",
  			data: {azione:'get-bookmarks', id_utente:uid, id_progetto:_pid}
  		})
  		.done(function(data) {
        if (data) {
          let bookmarks = JSON.parse(data)
          this.setState({bookmarks: bookmarks});
          this.creaListaLemmiBookmarked(this.state.lemmi,bookmarks)
        }
  		}.bind(this))
  		.fail(function(jqXHR, textStatus) {
  			$("#the-msg").html("Ops, qualcosa è andato storto...")
  		});
  }

  setBookmark = (id) => {

    if (!this.state.user) {
      alert('Accedi con il tuo account per aggiungere termini al bookmark')
      return
    }

    let bookmarks = this.state.bookmarks

    if (bookmarks.includes(id)) {
      bookmarks.splice(bookmarks.indexOf(id), 1)
    } else {
      bookmarks.push(id)
    }

    this.creaListaLemmiBookmarked(this.state.lemmi,bookmarks)

    this.setState({bookmarks: bookmarks})
    let dati = JSON.stringify(bookmarks)

  	$.ajax({
  			type: "POST",
  			url:  "php/services.php",
  			data: {azione:'set-bookmark', id_utente:this.state.user.id, id_progetto:_pid, dati_progetto:dati}
  		})
  		.done(function(data) {
        //
  		})
  		.fail(function(jqXHR, textStatus) {
  			$("#the-msg").html("Ops, qualcosa è andato storto...")
  		});
  }

  creaListaLemmiBookmarked = (l,b) => {

    let lista = []
    //let l = this.state.lemmi
    //let b = this.state.bookmarks
    for (let ii=0; ii<b.length; ii++) {
      for  (let jj=0; jj<l.length; jj++) {
        if (l[jj].medra===b[ii]) {
          lista.push(l[jj])
          break
        }
      }
    }
    lista.sort((a,b) => (a.termine > b.termine) ? 1 : ((b.termine > a.termine) ? -1 : 0))
    this.setState({lemmi_bookmarked: lista})

    //return lista
  }

  render() {

    let lemmi = this.state.lemmi;

    //if (this.state.bookmarks) lemmi = lemmi.filter(function(d) {return (d.bookmark==='1') });

    lemmi = lemmi.filter(function(d) {return (d.soc===this.state.categoria)||this.state.categoria===''; }.bind(this));

    let filtro = this.state.filtro.toLowerCase();
    lemmi = lemmi.filter(function(d) { return d.termine.toLowerCase().indexOf(filtro)!==-1; });

    let html_lemmi = [];
    if (this.state.lemmi) html_lemmi = lemmi.map(d => <div className="lemma" key={d.medra}><a onClick={()=> this.showLemma(d.medra)}>{d.termine}</a></div>);

    let option_categorie = '';
    if (this.state.categorie) option_categorie = this.state.categorie.map(d => <option key={d} value={d}>{d}</option>);

    let scheda = <div className="scheda"><div className="row"><div className="col-12"></div></div></div>

    let lista_bookmarks = 'Non hai ancora nessun bookmark salvato!'
    if (this.state.lemmi_bookmarked.length) {
      lista_bookmarks = this.state.lemmi_bookmarked.map(d => <div className="lemma" key={d.medra}><a href="#" onClick={()=> {this.showLemma(d.medra); $('#modal_bookmarks').modal('hide');}}>{d.termine}</a></div>);
    }
    /*
    if (this.state.bookmarks.length) {
      let lemmi_bookmarked = this.creaListaLemmiBookmarked() //NON OTTIMALE
      lista_bookmarks = lemmi_bookmarked.map(d => <div className="lemma" key={d.medra}><a href="#" onClick={()=> {this.showLemma(d.medra); $('#modal_bookmarks').modal('hide');}}>{d.termine}</a></div>);
    }
    */
    let filetto_2 =
      <nav className="navbar filetto-2">
        <div className="container container-filetto">
        {/*
          <div className="row">
            <div className="col-sm-12">
              <img src="img/colori1.png" />
            </div>
          </div>
        */}
        </div>
      </nav>

    let tooltip = this.state.user ? '' : 'Accedi con il tuo account per aggiungere termini al bookmark'

    if (this.state.lemma) {

      let stampa = this.state.mobile ? '' : <a className="link" onClick={()=>stampaScheda()}>{ico_stampa}{/*<img src="img/stampa.svg" width="30px" alt="S" title="stampa" />*/}</a>
      let preferiti = this.state.bookmarks.includes(this.state.lemma.medra) ? ico_bookmark_del : ico_bookmark_add

      let note = null
      if (this.state.lemma.note)
        note =
          <>
            <div className="lemma-label"><strong>Note di orientamento</strong></div>
            <div className="row mb-4">
              <div className="col-12 spiega">
                {this.state.lemma.note}
              </div>
            </div>
          </>

      scheda =
      <>
        <div className="scheda">
          <div id="lemma">
            <div className="row">
              {/*<div className="col-9 nome">*/}
              <div className="col-10 nome">
              Cod MedDRA {this.state.lemma.medra}
              </div>
              {/*
              <div className="col-1 nome">
                <a className="link" data-toggle="modal" data-target="#modal_email">{ico_email}</a>
              </div>
              */}
              <div className="col-1 nome">
                {stampa}
              </div>
              <div className="col-1 nome">
                <a className="link" onClick={()=>this.setBookmark(this.state.lemma.medra)}>{preferiti}</a>
              </div>
            </div>
            <div id="div-stampa">
              <div className="lemma-label"><strong>Evento avverso</strong></div>
              <div className="row mb-4">
                <div className="col-12 spiega">
                  {this.state.lemma.termine}
                </div>
              </div>
              <div className="lemma-label"><strong>Definizione</strong></div>
              <div className="row mb-4">
                <div className="col-12 spiega">
                  {this.state.lemma.definizione}
                </div>
              </div>
              <div className="lemma-label"><strong>Gradi</strong></div>
              <div className="row mb-4">
                <div className="col-12 spiega">
                  Grado 1: <span dangerouslySetInnerHTML={createMarkup(this.state.lemma.grado1)} /> <hr />
                  Grado 2: <span dangerouslySetInnerHTML={createMarkup(this.state.lemma.grado2)} /> <hr />
                  Grado 3: <span dangerouslySetInnerHTML={createMarkup(this.state.lemma.grado3)} /> <hr />
                  Grado 4: <span dangerouslySetInnerHTML={createMarkup(this.state.lemma.grado4)} /> <hr />
                  Grado 5: <span dangerouslySetInnerHTML={createMarkup(this.state.lemma.grado5)} />
                </div>
              </div>
              {note}
            </div>
          </div>
        </div>
        <div id="ico-up-mobile" className="text-center" onClick={()=>{$('html,body').animate({scrollTop:0},'slow');}}>{ico_up_mobile}</div>
      </>
    }

    let pagina = '';
    let introduzione = ''
    let subnavigator = ''

    if (this.state.pagina==="home") {
      introduzione =
        <div className="container container-1024" id="introduzione">
          <div className="row mt-3">
            <div className="col col-sm-12 intro">
              <p>La corretta registrazione degli eventi avversi che insorgono durante un trattamento oncologico riveste un ruolo di fondamentale importanza, sia nell'ambito degli studi clinici su nuove terapie sia nella pratica clinica con trattamenti già consolidati.</p>
              <p><strong>CTCAE Pocket</strong> offre un accesso rapido e intuitivo alla terminologia CTCAE (<em>Common Terminology Criteria for Adverse Events</em>), tradotta in italiano da Francesco Grossi ed Erika Rijavec, oncologi dell'Azienda Ospedaliera Metropolitana di Genova.</p>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col col-sm-12">
              <div className="continua float-right">
                <a href="#" onClick={()=>this.setState({pagina:'progetto'})}>continua a leggere > </a>
              </div>
            </div>
          </div>
        </div>
      subnavigator =
        <>
        <div className="subnavigator">
          <div className="container container-1024">
            <div className="row">
              <div className="col-8 col-sm-8">CTCAE | VERSIONE 6.0</div>
              <div className="col-4 col-sm-4 text-right">
                {this.state.user ? <a href="#" data-toggle="modal" data-target="#modal_bookmarks"><img className="icona" alt="bookmarks" src="img/bookmarks.svg" /></a> : null}
                <a href="#" onClick={()=>{this.changeDB('IT')}}><img className="icona ml-2 mr-2" alt="it" src="img/it.svg" /></a>
                <a href="#" onClick={()=>{this.changeDB('EN')}}><img className="icona" alt="en" src="img/en.svg" /></a>
              </div>
            </div>
          </div>
        </div>
        {filetto_2}
        </>

      pagina =
        <div className="container container-1024 h-100">
          <div className="row glossario">
            <div className="col-sm-12 col-md-6 mb-2">
              <div className="row col-12 filtro filtro-label">CLASSIFICAZIONE PER SISTEMI/ORGANI</div>
              <div className="row">
                <div className="col-12 filtro mb-5">
                  <select className="custom-select" value={this.state.categoria} onChange={this.changeCategoria}>
                    <option value=''>Tutte le classificazioni</option>
                    {option_categorie}
                  </select>
                </div>
              </div>
              <div className="row" id="div-lista-eventi-avversi">
                <div className="row col-12 filtro filtro-label">LISTA EVENTI AVVERSI</div>
                <div className="col col-12 filtro"><input className="form-control filtro-in" value={this.state.filtro} onChange={this.filterLemma} type="text" placeholder="cerca..." /></div>
              </div>
              <div className="row">
                <div className="col col-12 lemmi">{html_lemmi}</div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6" id="div-scheda">
              {scheda}
            </div>
          </div>
        </div>
    }

    if (this.state.pagina==="login") {

      subnavigator =
        <>
        <div className="subnavigator">
          <div className="container container-1024">
            <div className="titolo-pagina">{this.state.user?'PROFILO':'ACCEDI'}</div>
          </div>
        </div>
        {filetto_2}
        </>


      if (this.state.user) {

        let uri = 'https://registrazione.forumservice.net/?act=signup&key='+this.state.user.key+'&email='+this.state.user.email
        pagina =
          <div className="container container-1024">
            <div className="row">
              <div className="col-sm-12">
                <button type="button" className="btn btn-primary mb-3" onClick={()=>this.doLogout()}>Esci da questo account</button>
                <iframe className="iframe-account" src={uri}></iframe>
              </div>
            </div>
          </div>

      } else {

        pagina =
          <div className="container container-1024">
            <div className="row">
              <div className="col-sm-12 col-md-6 offset-md-3">
                <form id="the-login-form" onSubmit={this.doLogin}>
                  <div className="form-group">
                    <input type="text" className="form-control" id="username" name="username" placeholder="Username" required />
                  </div>
                  <div className="form-group">
                    <input type="password" className="form-control" id="password" name="password" placeholder="Password" required />
                  </div>
                  <button type="submit" className="btn btn-primary btn-100">Accedi</button>
                  <div className="mt-3 mb-2 text-center font-weight-bold" id="the-msg"></div>
                  <p className="mt-5 mb-3 text-center">oppure</p>
                  <button type="button" className="btn btn-primary btn-100 mb-5" onClick={()=>this.setState({pagina:'registrazione'})}>Registrati</button>
                  <p className="text-center">
                  <button type="button" className="btn btn-link" onClick={()=>this.registrazione('password')}>Hai dimenticato la password?</button>
                  <br />
                  <button type="button" className="btn btn-link" onClick={()=>this.registrazione('link')}>Non hai ricevuto il link di attivazione?</button>
                  </p>
                </form>
              </div>
            </div>
          </div>
      }
    }

    if (this.state.pagina==="registrazione") {

      let url = 'https://registrazione.forumservice.net/?act=signup&from='+_pid

      subnavigator =
        <>
        <div className="subnavigator">
          <div className="container container-1024">
            <div className="titolo-pagina">REGISTRAZIONE</div>
          </div>
        </div>
        {filetto_2}
        </>

      pagina =
        <div className="container container-1024">
          <div className="row">
            <div className="col-sm-12">
              <iframe className="iframe-account" src={url}></iframe>
            </div>
          </div>
        </div>
    }

    if (this.state.pagina==="progetto") {
      subnavigator =
        <>
        <div className="subnavigator">
          <div className="container container-1024">
            <div className="titolo-pagina">IL PROGETTO</div>
          </div>
        </div>
        {filetto_2}
        </>

      pagina =
        <div className="container container-1024 h-100">
          <Progetto />
        </div>
    }

    if (this.state.pagina==="guida") {
      subnavigator =
        <>
        <div className="subnavigator">
          <div className="container container-1024">
            {/*<div className="titolo-pagina">COME UTILIZZARE CTCAE POCKET</div>*/}
            <div className="titolo-pagina">NOTE INTRODUTTIVE</div>
          </div>
        </div>
        {filetto_2}
        </>

      pagina =
        <div className="container container-1024 h-100">
          <Guida />
        </div>
    }

    if (this.state.pagina==="splash") {

      return ( <Splash goHome={()=>{this.setState({pagina:'home'});}} /> )
    }

    return (

    <React.Fragment>

      <div id="app">

        <div className="fixed-top-xxxxxxxxx">

          <div className="top">
            <div className="container container-1024 mt-4">
              <div className="row">
                <div className="col-sm-12">
                  <a id="logo-ctcae" className="link" onClick={()=>this.setState({pagina:'home'})}><img src="img/logo_ctcae.svg" className="logo-ctcae float-left" alt="logo-ctcae" /></a>
                  <a id="logo-fs" className="link" href="https://forumservice.net" target="_blank"><img src="img/logo_fs.svg" className="logo-fs float-right" alt="logo-fs" /></a>
                  <a id="profilo-mobile" href="#" onClick={()=>this.setState({pagina:'login'})}>{ico_profilo}</a>
                </div>
              </div>
            </div>
          </div>

          <nav className="navbar filetto-1">
            <div className="container container-filetto">
              <div className="row">
                <div className="col-sm-12">
                  <img id="colori1" alt="colori" src="img/colori1.png" />
                </div>
              </div>
            </div>
          </nav>

          <nav className="navbar navbar-expand-lg navbar-dark bg-dark bg-primary">
            <div className="container container-1024" style={{"paddingLeft":"20px"}}>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    {
                      this.state.pagina==="home"
                      ? <a className="nav-link disabled" href="#">HOME</a>
                      : <a className="nav-link" href="#" onClick={()=>{$("#navbarSupportedContent").removeClass("show"); this.setState({pagina:'home'})}}>HOME</a>
                    }
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={()=>this.setState({pagina:'progetto'})}>PROGETTO</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={()=>this.setState({pagina:'guida'})}>NOTE</a>
                  </li>
                  <li className="nav-item voci-dx-1">
                    <a title={tooltip} className="nav-link" href="#" onClick={()=>this.setState({pagina:'login'})}>{this.state.user?'PROFILO':'ACCEDI '}<span className="ml-2">{ico_profilo}</span></a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {introduzione}
          {subnavigator}

        </div>

        <div className="page-wrap">{pagina}</div>

        <div className="row sponsor">
          <div className="col-sm-12 text-center">
            {<img src="https://siti.accmed.org/loghi_aziende/regeneron.svg" alt="sponsor" width="200" />}
          </div>
        </div>

        <footer className="py-3 pre-footer">
          <div className="container container-1024">
            <p className="m-0">
              Gli autori, l'editore e tutti quanti hanno preso parte alla realizzazione dell'opera non possono essere ritenuti in ogni caso responsabili degli errori concettuali derivanti dall'evolversi del pensiero clinico e neppure di quelli materiali in cui possono essere incorsi, nonostante tutto l'impegno dedicato a evitarli. L'autorizzazione alla riproduzione completa o in parte dei contenuti di questa pubblicazione deve essere richiesta a Francesco Grossi, responsabile scientifico della pubblicazione e autore dei contenuti.
            </p>
          </div>
        </footer>
        <footer className="py-3 footer">
          <div className="container">
            <p className="m-0 text-center text-white">
              &copy; Realizzato da <strong>Forum Service</strong><br />Tutti i diritti riservati | <a href="#" data-toggle="modal" data-target="#modal_cookie_policy">Cookie policy</a> | <a href="#" data-toggle="modal" data-target="#modal_privacy_policy">Privacy policy</a>
            </p>
          </div>
        </footer>

      </div>

      <div className="modal fade" id="modal_bookmarks" tabIndex="-1" role="dialog" aria-labelledby="modal_bookmarks" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_bookmarks">I MIEI BOOKMARKS</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body l-bookmark">
                {lista_bookmarks}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal_reg_16by9" tabIndex="-1" role="dialog" aria-labelledby="modal_reg2" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_reg2">ACCEDI</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="the-iframe-2">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe className="embed-responsive-item" id="IframeId-16by9" src="#"></iframe>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>
      {/*
      <div className="modal fade" id="modal_email" tabIndex="-1" role="dialog" aria-labelledby="modal_emailLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_emailLabel">EMAIL</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Email />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>
      */}
      <div className="modal fade" id="modal_cookie_policy" tabIndex="-1" role="dialog" aria-labelledby="modal_cookie_policyLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_cookie_policyLabel"></h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe title="cookiepolicy" frameBorder="0" src="https://www.forumservice.net/cookiepolicy.html"></iframe>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="modal_privacy_policy" tabIndex="-1" role="dialog" aria-labelledby="modal_privacy_policyLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_privacy_policyLabel"></h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe title="cookiepolicy" frameBorder="0" src="https://www.forumservice.net/privacypolicy.html"></iframe>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
    );
  }
}

class Progetto extends Component {

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12 ridotto">
            <p>La corretta registrazione degli eventi avversi che insorgono durante un trattamento oncologico riveste un ruolo di fondamentale importanza, sia nell'ambito degli studi clinici su nuove terapie sia nella pratica clinica con trattamenti già consolidati.</p>
            <p><strong>CTCAE Pocket</strong> offre un accesso rapido e intuitivo alla terminologia CTCAE (<em>Common Terminology Criteria for Adverse Events</em>), tradotta in italiano da Francesco Grossi ed Erika Rijavec, oncologi dell'Azienda Ospedaliera Metropolitana di Genova.</p>
            <p>Il CTCAE nasce con l'obiettivo di fornire uno standard condiviso per la descrizione, la classificazione e lo scambio di informazioni relative agli eventi avversi e alla sicurezza dei trattamenti in ambito oncologico. Per ciascun evento avverso, il CTCAE prevede una scala di grading che consente di definirne la severità.</p>
            <p>Il CTCAE viene utilizzato per definire parametri fondamentali all'interno dei protocolli clinici, quali la dose massima tollerata e la tossicità dose-limitante, oltre che per supportare la valutazione dell'eleggibilità dei pazienti e fornire indicazioni per l'aggiustamento posologico.</p>
            <p>L'utilizzo del CTCAE facilita inoltre la valutazione di nuove terapie oncologiche, l'analisi delle diverse modalità di trattamento e il confronto tra i profili di tossicità associati alle varie opzioni terapeutiche, contribuendo a rendere più omogenea e riproducibile la raccolta dei dati di sicurezza.</p>
            <p>Nel 2025, il National Cancer Institute (NCI) ha pubblicato la versione 6.0 del CTCAE attualmente in uso, sulla quale si basa questa versione di CTCAE Pocket.</p>
            <p>CTCAE Pocket è stato sviluppato per semplificare la consultazione e l'utilizzo quotidiano del CTCAE, sia negli studi clinici sia nella pratica clinica. L'app consente di accedere a oltre ottocento voci del database, disponibili in inglese e in italiano, tramite ricerca diretta oppure attraverso la classificazione degli eventi avversi secondo le <em>System Organ Classes</em> (SOC) del MedDRA (<em>Medical Dictionary for Regulatory Activities</em>).</p>
            <p>La disponibilità di una traduzione italiana rappresenta un valore aggiunto significativo, poiché favorisce una comprensione più immediata dei termini, riduce il rischio di interpretazioni non uniformi e supporta l'utilizzo coerente del CTCAE da parte dei professionisti sanitari coinvolti nella gestione del paziente oncologico.</p>
            <p>In questo modo, CTCAE Pocket favorisce un approccio strutturato, rapido e coerente con gli standard internazionali per la segnalazione, la valutazione e la gestione della tossicità nei trattamenti oncologici.</p>
          </div>
        </div>

        <div className="row mt-4 mb-2">
          <div className="col-12"><strong>RESPONSABILE SCIENTIFICO</strong></div>
        </div>

        <div className="row mb-4">
          <div className="col-sm-12 col-md-4 pr-1 ridotto">
            <p>
              <strong>Francesco Grossi</strong><br />
              Direttore UO Oncologia Medica<br />
              Azienda Ospedaliera Metropolitana<br />
              IRCCS Ospedale Policlinico San Martino<br />
              Genova
            </p>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-12"><strong>AUTORI</strong></div>
        </div>

        <div className="row mb-4">
          <div className="col-sm-12 col-md-4 pr-1 ridotto">
            <p>
              <strong>Francesco Grossi</strong><br />
              Direttore UO Oncologia Medica<br />
              Azienda Ospedaliera Metropolitana<br />
              IRCCS Ospedale Policlinico San Martino<br />
              Genova
            </p>
          </div>
          <div className="col-sm-12 col-md-8 pl-2 ridotto">
            <p>
              <strong>Erika Rijavec</strong><br />
              U.O. Oncologia Medica<br />
              Azienda Ospedaliera Metropolitana<br />
              Ospedale Villa Scassi<br />
              Genova
            </p>
          </div>
        </div>

      </>
    )
  }
}

class Guida extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 ridotto">
          <strong>QUICK REFERENCE</strong>
          <p>I <em>Common Terminology Criteria for Adverse Events</em> (CTCAE) del National Cancer Institute (NCI) rappresentano una terminologia descrittiva standardizzata utilizzata per la segnalazione degli eventi avversi (EA). Per ciascun termine descrittivo di un evento avverso è prevista una scala di severità espressa in gradi.</p>
          <p><strong>SOC: componenti e organizzazione</strong></p>
          <p>La <em>System Organ Class</em> (SOC) rappresenta il livello più alto della gerarchia MedDRA. Si tratta di una classificazione per sistemi e organi, definita su base anatomica o fisiologica, eziologica oppure in relazione alla finalità della categoria. Un esempio è la SOC "Indagini", che comprende eventi avversi relativi ai risultati di esami di laboratorio o strumentali.</p>
          <p>I termini CTCAE sono raggruppati in base alle principali SOC MedDRA. All'interno di ciascuna SOC, gli eventi avversi sono elencati insieme alla descrizione della relativa severità, espressa in gradi.</p>
          <p><strong>Termini CTCAE</strong></p>
          <p>Per evento avverso si intende qualsiasi evento inatteso o sfavorevole, compreso un risultato di laboratorio fuori norma, un sintomo o un processo patologico temporalmente associato a una terapia medica o a una procedura, indipendentemente dal fatto che sia considerato correlato o meno al trattamento o alla procedura stessa.</p>
          <p>L'evento avverso è un termine utilizzato nella documentazione medica e nell'analisi dei dati scientifici per rappresentare in modo univoco uno specifico evento clinico. Ogni termine CTCAE corrisponde a un termine di basso livello (<em>Lowest Level Term</em>, LLT) del dizionario MedDRA.</p>
          <p><strong>Definizioni</strong></p>
          <p>Per ciascun evento avverso è riportata una breve definizione, utile a chiarire il significato del termine e a favorirne un'interpretazione uniforme.</p>
          <p><strong>Gradi</strong></p>
          <p>Il grado indica la severità dell'evento avverso. Il CTCAE utilizza una scala da 1 a 5, accompagnata da una descrizione clinica specifica della severità di ciascun evento, secondo le seguenti indicazioni generali:</p>
          <p>Grado 1: lieve; asintomatico o caratterizzato da sintomi lievi; richiede solo osservazione clinica o diagnostica; non è indicato un intervento specifico.</p>
          <p>Grado 2: moderato; è indicato un intervento minimo, locale o non invasivo; comporta una limitazione delle attività strumentali della vita quotidiana (<em>Instrumental Activities of Daily Living</em>, ADL) adeguate all'età.</p>
          <p>Grado 3: grave o clinicamente significativo, ma non immediatamente pericoloso per la vita; è indicata l'ospedalizzazione o il prolungamento del ricovero; invalidante; limita le attività della vita quotidiana relative alla cura della persona (<em>Self-care ADL</em>).</p>
          <p>Grado 4: conseguenze potenzialmente letali; è indicato un intervento urgente.</p>
          <p>Grado 5: morte correlata all'evento avverso.</p>
          <p>Un punto e virgola nella descrizione del grado significa "oppure".<br />
          Un singolo trattino (-) indica l'assenza di uno specifico grado.<br />
          Non tutti i gradi sono appropriati per tutti gli eventi avversi; pertanto, alcuni eventi sono elencati con meno di cinque opzioni di grading.<br />
          Il Grado 5, corrispondente al decesso, non è appropriato per alcuni eventi avversi e, in questi casi, non rappresenta un'opzione disponibile.</p>
          <p><strong>Attività della vita quotidiana — ADL</strong></p>
          <p>*Nota 1 — <em>Instrumental</em> ADL: attività strumentali della vita quotidiana, quali preparare i pasti, fare la spesa o acquistare vestiti, usare il telefono, gestire il denaro e svolgere altre attività necessarie alla vita autonoma.</p>
          <p>**Nota 2 — <em>Self-care</em> ADL: attività della vita quotidiana relative alla cura della persona, come lavarsi, vestirsi e svestirsi, alimentarsi autonomamente, andare alla toilette, assumere i farmaci e non essere costretti a letto.</p>
          <p><strong>Acronimi</strong></p>
          <p>INR: <em>International Normalized Ratio</em>, rapporto internazionale normalizzato<br />
          LIN: limite inferiore di normalità<br />
          LSN: limite superiore di normalità<br />
          NPT: nutrizione parenterale totale<br />
          pRBCs: <em>packed Red Blood Cells</em>, concentrato di eritrociti</p>
        </div>
      </div>
    )
  }
}

class Splash extends Component {

  constructor(props, context) {

    super(props, context);

    this.state = {
      check_code:false,
      send_email:false,
    };

  }

  entra = () => {

    if (typeof (Cookies.get('access_code')) !== 'undefined')
      this.props.goHome()
    else
      $('#modal_entra').modal('show')
  }

  checkCode = () => {

    if (!$("#access_code").val()) return
    /*
    hashString($("#access_code").val()).then(hash => {
      if (hash===accessCode) {
        $('#modal_entra').modal('hide')
        this.props.goHome()
        Cookies.set('access_code', true, { expires: 365 })
      } else {
        alert('Codice errato.')
      }
    });
    */
    let data = "azione=check-code&code="+$("#access_code").val()

    $.ajax({
    		type: "POST",
    		url:  "php/services.php",
        data: data
    	})
    	.done(function(d) {
        if (d) {
          $('#modal_entra').modal('hide')
          this.props.goHome()
          Cookies.set('access_code', true, { expires: 365 })
        } else {
          alert('Codice errato.')
        }
    	}.bind(this))
    	.fail(function(jqXHR, textStatus) {
    		alert("Ops, qualcosa è andato storto...");
    	});

  }

  sendEmail = (event) => {

    if (!$("#access_email").val()) return

    if (!$("#privacy").is(':checked')) {
      alert("Devi confermare di aver letto l'informativa sulla privacy")
      return
    }

    let data = "email="+$("#access_email").val()

    $.ajax({
    		type: "POST",
    		url:  "php/email.php",
        data: data
    	})
    	.done(function(sHtml) {
    		alert("Richiesta inviata. Controlla la tua casella di posta per verificare la ricezione del codice")
    	})
    	.fail(function(jqXHR, textStatus) {
    		alert("Ops, qualcosa è andato storto...");
    	});
  }

  render() {

    let ask_email = null
    if (this.state.send_email) {
      ask_email =
        <>
          <h6>RICHIESTA CODICE DI ACCESSO</h6>
          <p className="ridotto">Inserisci la tua mail per ricevere il codice direttamente nella tua casella di posta</p>
          <div className="mb-4">
            <div className="form-group input-group-sm mb-2 mr-2">
              <input type="email" className="form-control" id="access_email" placeholder="Email" />
            </div>
            <p className="ridotto">
              <input id="privacy" type="checkbox" className="mr-1" />
              Ho letto l'informativa sulla <a target="_blank" href="https://www.forumservice.net/privacypolicy.html">privacy</a>
            </p>
            <button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.sendEmail()}}>Richiedi codice</button>
          </div>
        </>
    }

    let ask_check_code = null
    if (this.state.check_code) {
      ask_check_code =
        <div className="mt-5 mb-5">
          <h6>CODICE DI ACCESSO</h6>
          <p className="ridotto">Inserisci il codice in tuo possesso per proseguire.</p>
          <div className="mb-5">
            <div className="form-group input-group-sm mb-2 mr-2">
              <input type="password" className="form-control" id="access_code" placeholder="Codice" />
            </div>
            <button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.checkCode()}}>Accedi</button>
            <a className="btn btn-sm btn-link" onClick={()=>{this.setState({send_email:true})}}>Richiedi codice di accesso</a>
          </div>
          {ask_email}
        </div>
    }

    return (
      <>
      <div className="bg-bianco">
          <div className="container container-1024 testa">
              <div className="row mt-4">
                  <div className="col-md-6">
                  </div>
                  <div className="col-md-6 logo-fs-splash">
                      <img src="img/logo_fs.svg" alt="Forum Service" />
                  </div>
              </div>
          </div>
          <div className="banner">
            <div className="container-md">
              <div className="row">
                  <div className="col-md-6 text-left">
                      <img src="img/logo_ctcae.svg" alt="CTCAE" />
                  </div>
              </div>
            </div>
          </div>
      </div>
      <div className="bg-blu autore">
          <div className="container-md">
              <div className="row">
                  <div className="col-md-12 text-left">
                      <p>A cura di Francesco Grossi ed Erika Rijavec</p>
                  </div>
              </div>
          </div>
      </div>
      <div className="bg-grigio">
          <div className="container-md">
              <div className="row">
                  <div className="col-md-6 mt-4 testo-splash">
                      <p>La corretta registrazione degli Eventi Avversi che insorgono durante un trattamento oncologico è di estrema importanza sia nell'ambito degli studi clinici su nuove terapie, sia nella pratica clinica con trattamenti consolidati.</p>
                      <p><b>CTCAE Pocket</b> fornisce un rapido accesso alle oltre ottocento voci del database CTCAE (<i>Common Terminology Criteria for Adverse Events</i>, versione 6.0) sia in inglese sia in italiano.
                        La consultazione è possibile attraverso la ricerca diretta oppure mediante la classificazione degli Eventi Avversi secondo i <i>System Organ Class</i> (SOC) del MedDRA (<i>Medical Dictionary for Regulatory Activities</i>), garantendo un approccio strutturato e allineato agli standard internazionali per la segnalazione e la valutazione della tossicità.
                      </p>
                  </div>
                  <div className="col-md-6 showcase">
                      <p><img src="img/showcase-x.png" alt="Showcase" /></p>
                  </div>
              </div>
          </div>
          <div className="container-md text-center mb-5 payoff">
            <div className="row">
              <div className="col-md-12">
                <a href="#" className="btn btn-primary btn-entra" onClick={()=>{this.entra()}}>ENTRA</a>
                <div className="mt-5 continua"><i>Con la sponsorizzazione non condizionante di</i></div>
                <div className="mt-4"><img className="logo-sponsor" src="https://siti.accmed.org/loghi_aziende/regeneron.svg" /></div>
              </div>
            </div>
          </div>
      </div>

      <div className="modal fade" id="modal_entra" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="modal_entra_label" aria-hidden="true">
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_entra_label">Accesso a CTCAE</h5>
            </div>
            <div className="modal-body">
              <div className="mb-3">In ragione dei suoi contenuti, l'accesso a questa applicazione web è riservato ai soli operatori sanitari. Per procedere, devi completare la seguente auto-dichiarazione.</div>
              {/*<button type="button" className="btn btn-primary btn-sm mr-1 mb-1" data-dismiss="modal" onClick={()=>{this.props.goHome()}}>Sono un Operatore Sanitario</button>*/}
              <button type="button" className="btn btn-primary btn-sm mr-1 mb-1" onClick={()=>{this.setState({check_code:true})}}>Sono un Operatore Sanitario</button>
              <button type="button" className="btn btn-secondary btn-sm mb-1" data-dismiss="modal">NON sono un Operatore Sanitario</button>
              {ask_check_code}
            </div>
            <div className="modal-footer">
            </div>
          </div>
        </div>
      </div>

      {/*
      <div className="container-md text-center pb-5 sponsor-splash">
        <div className="row">
          <div className="col-md-12">
            <p><img width="300px" src="https://siti.accmed.org/loghi_aziende/regeneron.svg" alt="Regeneron" /></p>
          </div>
        </div>
      </div>
      */}

      </>
    )
  }
}

/*
class Email extends Component {

  sendEmail = (e) => {

    e.preventDefault()
    e.stopPropagation()

    let messaggio = '<b>Evento avverso:</b> '+_lemma.termine+'<br />'
    messaggio += '<b>Definizione:</b> '+_lemma.definizione+'<br />'
    messaggio += '<b>Grado 1:</b> '+_lemma.grado1+'<br />'
    messaggio += '<b>Grado 2:</b> '+_lemma.grado2+'<br />'
    messaggio += '<b>Grado 3:</b> '+_lemma.grado3+'<br />'
    messaggio += '<b>Grado 4:</b> '+_lemma.grado4+'<br />'
    messaggio += '<b>Grado 5:</b> '+_lemma.grado5+'<br />'

    let data = $("#the-form").serialize()+"&messaggio="+messaggio;

    $('#the-result').html('<div className="loading"><p><img src="img/loader.gif" width="100" height="100" alt="loader"></p></div>');
    $.ajax({
    		type: "POST",
    		url:  "php/email.php",
    		data: data
    	})
    	.done(function(sHtml) {
    		if (sHtml) $("#the-result").html("Attenzione, il messaggio non è stato inviato! Forse hai dimenticato di cliccare il reCAPTCHA?"); else $("#the-result").html("Messaggio inviato correttamente!");
    	})
    	.fail(function(jqXHR, textStatus) {
    		$("#the-result").html("Ops, qualcosa è andato storto...");
    	});
  }

  render() {

    return (
      <React.Fragment>
        <form id="the-form" onSubmit={this.sendEmail}>
          <div className="row">
            <div className="col-12">
              <input id="email" name="email" className="form-control" type="email" required="required" placeholder="La tua email" /><br />
            </div>
            <div className="col-12 recaptcha">Sei umano? Clicca qui sotto, grazie!</div>
            <div className="col-12 recaptcha"><ReCAPTCHA sitekey="6Ld3PC8jAAAAANvEI-GSpUbolSywZV54qsrZCrl6" /></div>
            <div className="col-12 recaptcha"><button className="btn btn-primary email" type="submit">Invia</button></div>
            <div className="col-12" id="the-result"></div>
          </div>
        </form>
      </React.Fragment>
    )
  }
}
*/

/*
class Credits extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 ridotto">
          <p><strong>Coordinamento scientifico</strong></p>
          Accademia Nazionale di Medicina<br />
          Via M. Piaggio 17/6 - 16122 Genova GE<br />
          T. +39 010.837.94.1 | F. +39 010.837.94.260<br />
          <a href="https://www.accmed.org" target="_blank" rel="noopener noreferrer">https://www.accmed.org</a>, <a href="mailto:info.anm@accmed.org">info.anm@accmed.org</a><br />
          Direttore generale: Stefania Ledda<br /><br />
          <p><strong>Sviluppo applicazione</strong></p>
          Forum Service S.r.l<br />
          Via M. Piaggio 17/6 - 16122 Genova GE<br />
          T. +39 010.837.94.1 | F. +39 010.837.94.261<br />
          <a href="https://www.forumservice.net" target="_blank" rel="noopener noreferrer">https://www.forumservice.net</a>, <a href="mailto:info.fs@forumservice.net">info.fs@forumservice.net</a><br /><br />
          <p><em>Copyright © 2022 Realizzato da Forum Service. - Tutti i diritti riservati. Gli autori, e tutti quanti hanno preso parte alla realizzazione dell’opera non possono essere ritenuti in ogni caso responsabili degli errori concettuali derivanti dall’evolversi del pensiero clinico e neppure di quelli materiali in cui possono essere incorsi, nonostante tutto l’impegno dedicato a evitarli. L’autorizzazione alla riproduzione completa o in parte dei contenuti di questa applicazione deve essere richiesta.</em></p>

          <p>&nbsp;</p>
          <p><a href="https://www.sanofi.it/" target="_blank" rel="noopener noreferrer"><img src="img/sponsor.svg" width="150" /></a></p>

        </div>
      </div>
    )
  }
}
*/

function stampaScheda() {

    //var content = document.getElementById("lemma").innerHTML;
    var content = document.getElementById("div-stampa").innerHTML;
    var mywindow = window.open('', 'Print', 'height=600,width=800');

    mywindow.document.write('<html><head><title>Stampa</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus()
    mywindow.print();
    mywindow.close();
    return true;
}

function createMarkup(html) { return {__html: html}; };

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setAccessCookie() {
  var d = new Date();
  var days = 365;
  d.setTime(d.getTime() + (days*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = "access_code=1;" + expires + ";";
}

/* non funziona nella build, peccato :(
async function hashString(str) {
  // Converti la stringa in un array di byte
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  // Calcola l'hash usando SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  // Converti il risultato in una stringa esadecimale
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
*/

export default App;
